export default "__VITE_ASSET___5xTEBhs__"